import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withVariants } from '../util';
const Small = (_jsx("svg", Object.assign({ width: "17", height: "25", viewBox: "0 0 17 25" }, { children: _jsxs("g", Object.assign({ fill: "currentColor", fillRule: "evenodd" }, { children: [_jsx("path", { d: "M0 25h17V0H0v25zm1-1h15V1H1v23z" }, void 0), _jsx("path", { d: "M7 5h1V.999H7zM9 5h1V.999H9z" }, void 0), _jsx("path", { d: "M6 5h4.999V4H6zM3 9h5V8H3zM9 9h5V8H9zM3 12h5v-1.001H3zM9 12h5v-1.001H9zM3 15h5v-1H3zM9 15h5v-1H9zM3 18h5v-1H3zM9 18h5v-1H9zM3 21h5v-1.001H3zM9 21h5v-1.001H9z" }, void 0)] }), void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
